import { render, staticRenderFns } from "./tujuan_pembelajaran.vue?vue&type=template&id=eeb26872&scoped=true&"
import script from "./tujuan_pembelajaran.vue?vue&type=script&lang=js&"
export * from "./tujuan_pembelajaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb26872",
  null
  
)

export default component.exports